import { Component, Input, OnChanges, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { ColumnInfo } from '../../models/column-info.type';

@Component({
  selector: 'bt-table',
  standalone: false,
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss'
})
export class TableComponent {

  @Input() dataSource: Array<any> = [];
  @Input() displayedColumns: Array<ColumnInfo> = [];
  @Input() action: boolean = false;
  @Input() pagination: boolean = false;
  @Input() pageNumber: number = 0;
  @Input() pageSize: number = 0;
  @Input() totalNumber: number = 0;

  @Output() emitAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickPage: EventEmitter<any> = new EventEmitter<any>();

  actionEmitter(item: any): void {
    this.emitAction.emit(item);
  }

  clickPageEmitter(event: any): void {
    this.clickPage.emit(event);
  }

}
